<!-- AddConsumableModal.vue -->
<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 40vw">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">Add Consumable</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <form @submit.prevent="submitForm" class="form-grid">
          <div class="form-group">
            <label for="item_name">Item Name</label>
            <!-- <input
              type="text"
              id="item_name"
              v-model="form.item_name"
              placeholder="e.g., Adhesive Bandage"
              required
            /> -->
            <iteminput
              @itemoption-check="take_item"
              Rowid="0"
              type="items"
              preselectedItem=""
            />
          </div>

          <div class="form-group">
            <label for="quantity">Quantity</label>
            <input
              type="number"
              id="quantity"
              v-model.number="form.quantity"
              placeholder="e.g., 50"
              required
            />
          </div>
        </form>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn cancel" @click="closeModal">
          Cancel
        </button>
        <button type="button" class="btn save" @click="submitForm">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import { JsItemName } from "../components/jscomponents";
import iteminput from "../components/iteminput.vue";
export default {
  name: "AddConsumableModal",
  data() {
    return {
      form: {
        item_name: "",
        quantity: null,
        item_id: null,
      },
    };
  },

  props: {
    serviceIdentity: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    iteminput,
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    take_item(option, row) {
      console.log(row);
      console.log(option);

      this.form.item_name = JsItemName(
        option.brand_name,
        option.item_strength,
        option.item_name
      );
      this.form.item_id = option.item_id;
    },
    async submitForm() {
      // Only proceed if the required fields are filled out.
      if (this.form.item_name && this.form.quantity) {
        // Emit a 'save' event to the parent component.
        this.$emit("save", { ...this.form });

        const url = "consumables";
        const body = {
          item_id: this.form.item_id,
          quantity: this.form.quantity,
          store_id: 2,
          department_id: 2, // 2 is lab
          service_id: this.serviceIdentity,
        };

        try {
          // Await the asynchronous API call.
          // This line will pause execution until the promise resolves or rejects.
          const data = await generalApiRequest(url, "POST", body, 1);
          console.log("API response:", data);

          // If the API call is successful, then we can safely reset the form.
          // This is the key change to prevent data loss on failure.
          this.form = { item_name: "", quantity: null };
          this.closeModal();
        } catch (error) {
          // If the API call fails, this block will execute.
          // We log the error but DO NOT reset the form.
          // This allows the user to see their entered data and try again.
          console.error("API call failed:", error);
          this.closeModal();
          // You could also set a state variable to show an error message to the user, e.g., this.errorMessage = 'Failed to save.';
        }
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  border-radius: 10px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  padding: 1rem;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.close {
  background: #e74c3c;
  border: none;
  font-size: 1.5rem;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s;
}
.close:hover {
  background: #c0392b;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.form-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group label {
  font-weight: 500;
  margin-bottom: 0.3rem;
  display: block;
  color: #444;
}
.form-group input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
}
.form-group input:focus {
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.modal-footer {
  border-top: 1px solid #ddd;
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.btn {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  border: none;
}

.btn.cancel {
  background: #bdc3c7;
  color: #2c3e50;
}
.btn.cancel:hover {
  background: #95a5a6;
}

.btn.save {
  background: #27ae60;
  color: white;
}
.btn.save:hover {
  background: #1e8449;
}
</style>
